import {Component, OnInit, ViewChild, HostListener} from '@angular/core';
import { first } from 'rxjs/operators';
import { VirtualFolderNode } from 'src/app/_models/virtualFolder';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MatTableDataSource } from '@angular/material/table';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfig } from 'src/assets/config/config/app-config';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/_models/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { FileInboxVirtualFolderService } from 'src/app/_services/fileInbox-virtualFolder.service';
import { DialogCaptureUploadComponent } from '../dialog-capture-upload/dialog-capture-upload.component';
import { DocumentService } from 'src/app/_services/document.services';
import { MigrationService } from 'src/app/_services/document-migration.services';
import { AlertService } from 'src/app/_services/alert.service';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { Stack } from 'src/app/_helpers/custom-stack';

interface FolderFlatNode {
  expandable: boolean;
  id: number;
  folder_name: string;
  parent_id: number;
  level: number;
  type: string;
  team_id: number;
}

@Component({
  selector: 'app-folder-view',
  templateUrl: './folder-view.component.html',
  styleUrls: ['./folder-view.component.scss']
})
export class FolderViewComponent implements OnInit {
  // @Output() isCreateFolder = new EventEmitter<boolean>();
  // @Output() isUpdateFolder = new EventEmitter<boolean>();
  noDocuments: any;
  checkFolders: any;
  // folders: any;
  navBarFolders: any[];
  navBarTeams: any[];
  filterValue: string;
  url: string;
  folderDetails: any;
  folders = [];
  teams = [];
  selectedParentTeam: any;
  selectedFolderName: any;
  selectedFolderId: any;
  selectedTeamName: any;
  selectedTeamId: any;
  selectedType: any;
  selectedTab: string = 'Folder';
  folderSelected: boolean = false;
  isMainPage: boolean = false;
  isCreateFolder: boolean = false;
  isCreateSubFolder: boolean = false;
  isUpdateFolder: boolean = false;
  currentUser: User;
  documents: any;
  totalDocumentCount: number = 0;
  offset: number = 0;
  selectedDoc: String;
  loadNext: boolean = false;
  loadPrevious: boolean = false;
  documentCount: number = 0;
  documentCols: String[] = [];
  docResultsList: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);
  folderCreated: any;
  fullPath: any;
  teamSelectMessage: boolean =false;
  //private ithService:ImageTrustService
  width = '100';
  selectedRow: Array<JSON> = [];
  hideDocList: Boolean = false;
  sort;
  iframeUrl = null;
  loading = false;
  displayImageTrust = false;
  allVirtualFolders;
  allVirtualTeams;
  noFolders:boolean = false;
  noTeams:boolean = false;
  internalGroupIdentifiers: string[]
  usersList:string[]=[]
  groupList: string[]
  teamList = [];

  pageSize = 50;
  pageIndex = 0;
  currentPageSize = 0;
  currentStartPageIndex = 0;
  totalDoc: number = 0;  

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer,
    public dialog: MatDialog,
    private virtualFolderService: FileInboxVirtualFolderService,
    private config: AppConfig,
    private authenticationService: AuthenticationService,
    // public dialogRef: MatDialogRef<DialogFolderComponent>,
    private applicationConfig: AppConfig,
    private documentService: DocumentService,
    private migrationService: MigrationService,
    private alertService: AlertService,
    private httpClient: HttpClient
  ) {
    this.matIconRegistry.addSvgIcon(
      'pdf',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/pdf.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'jpeg',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/jpg.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'ppt',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/ppt.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xls',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/xls.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'txt',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/txt.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'doc',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/doc.svg')
    );
  }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.groupList = this.authenticationService.userGroupsValue;
    this.internalGroupIdentifiers = this.applicationConfig.getInternalGroupsIdentifier();
    let cacheFolderId = Number(localStorage.getItem('fileInboxFolderId'));
    if (cacheFolderId && cacheFolderId > 0) {
      this.selectedFolderId = cacheFolderId;
    }
    if (!this.authenticationService.isAdminValue) {
      if (this.internalGroupIdentifiers) {
        this.internalGroupIdentifiers.forEach(internalGroupIdentifier => {
          this.groupList.forEach((group) => {
            if (group.includes(internalGroupIdentifier)) {
              this.groupList = this.groupList.filter(obj => obj !== group);
            }
          })
        });
      }
    }
    this.getVirtualFoldersTree(); 
    this.migrationService.getTeamsAll().subscribe(teams => {
      if (teams && teams.length > 0) {
         for (var index in teams) {
            if (!this.teamList.includes(teams[index].team_name)) {
              this.teamList.push(teams[index]);
            }
         }
      }
    });   
  }

  onTabChange(tabName: string) {
    if (tabName == 'Folder') {
      this.selectedTab = tabName;
      this.getVirtualFoldersTree();      
    } else {
      this.selectedTab = tabName;
      this.getVirtualTeamsTree();     
    }
    this.deselectAll();
  }

  private _transformer = (node: VirtualFolderNode, level: number) => {
    return {
      expandable: !!node.sub_folders && node.sub_folders.length > 0,
      id: node.id,
      folder_name: node.folder_name,
      level: level,
      parent_id: node.parent_id,
      type: node.type,
      team_id: node.team_id
    };
  };
  treeControl = new FlatTreeControl<FolderFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.sub_folders
  );
  virtualFolders = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );

  teamTreeControl = new FlatTreeControl<FolderFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  teamTreeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.sub_folders
  );
  virtualTeams = new MatTreeFlatDataSource(
    this.teamTreeControl,
    this.teamTreeFlattener
  );
  hasChild = (_: number, node: FolderFlatNode) => node.expandable;

  @ViewChild(MatDrawerContainer) drawerContainer: MatDrawerContainer;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.docResultsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.docResultsList.paginator = this.paginator;
    }
  }

  // @HostListener('window:message', ['$event'])
  // onClientLoadedAndWindowClosed(event: any): void {
  //   if (typeof event.data == 'string' && event.data.includes('loaded')) {
  //     // this.onHideDocList(false);
  //     this.loading = false;
  //     window.postMessage(
  //       'Thanks for sharing the info with me',
  //       'https://dev-docuedge-review.fxedw.com/'
  //     );
  //   }

  //   if (typeof event.data == 'string' && event.data.includes('close')) {
  //     this.onHideDocList(false);
  //   }
  // }

  async getFlattenedVirtualFolders(){    
      this.allVirtualFolders= await this.virtualFolderService.getFlattenedTree(); 
      const folderStack = new Stack<number>();
      let isRootNode = false;      
      let id = this.selectedFolderId;
      if (this.allVirtualFolders && this.allVirtualFolders.length > 0 && this.selectedFolderId > 0) {
        while(!isRootNode) {
          let selectedFolder = this.allVirtualFolders.filter(folder => folder.id == id);
          if (selectedFolder && selectedFolder.length > 0) {            
            if (selectedFolder[0].parent_id == 0) {
              isRootNode = true;
            } else {
              folderStack.push(selectedFolder[0].parent_id);
              id = selectedFolder[0].parent_id;
            }
          } else {
            isRootNode = true;
          }
        }
        while(!folderStack.isEmpty()) {
          let id = folderStack.pop();
          let treeList = this.virtualFolders._expandedData.value.filter((node) => node.id == id);
          if (treeList.length > 0) {
              this.treeControl.expand(treeList[0]);                    
          }
        }
      }
      this.selectFolder(this.selectedFolderName, this.selectedFolderId);   
  }

  private getVirtualFoldersTree() {
    this.virtualFolderService
      .getTree()
      .pipe(first())
      .subscribe((folders) => {
        if(folders.length == 0){
          this.noFolders = true
        } else {
          if (this.selectedFolderId > 0) {
            let selectedFolderList = folders.filter((folder) => folder.id === this.selectedFolderId);
            if (selectedFolderList.length > 0) {
              this.selectedFolderName = selectedFolderList[0]['folder_name'];
            }
          } else {
            this.selectedFolderName = folders[0]['folder_name'];
            this.selectedFolderId = folders[0]['id'];          
          }
          this.noFolders = false
          this.virtualFolders.data = folders;
          this.folders = folders;          
          this.navBarFolders = folders;
          this.navBarFolders.sort = this.sort; 
          this.getFlattenedVirtualFolders();          
        }
      });
  }

async getFlattenedVirtualTeams(){    
    this.allVirtualTeams = await this.migrationService.getFlattenedTeamTree();
    this.selectTeam(this.selectedTeamName, this.selectedTeamId, this.selectedType, this.selectedParentTeam);   
}

private getVirtualTeamsTree() {
  this.migrationService
    .getTeamsTree()
    .pipe(first())
    .subscribe((teams) => {
      if(teams.length == 0){
        this.noTeams = true          
      } else {
        this.selectedTeamName = teams[0]['folder_name'];
        this.selectedTeamId = teams[0]['id'];          
        this.selectedType = teams[0]['type'];
        this.selectedParentTeam = teams[0]['parent_id'];
        this.noTeams = false
        this.virtualTeams.data = teams;
        this.teams = teams;          
        this.navBarTeams = teams;
        this.navBarTeams.sort = this.sort; 
        this.getFlattenedVirtualTeams();          
      }
    });
}

  applyFilterOnFolders(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    if (this.filterValue.length > 0) {
      this.navBarFolders = [];
      this.search();
    } else {
      this.virtualFolders.data = this.folders;
    }
  }

  applyFilterOnTeams(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    if (this.filterValue.length > 0) {
      this.navBarTeams = [];
      this.searchTeams();
    } else {
      this.virtualTeams.data = this.folders;
    }
  }

  applyFilter(filterValue) {
    //const filterValue = (event.target as HTMLInputElement).value;
    this.docResultsList.filter = filterValue.trim().toLowerCase();
    if (this.docResultsList.paginator) {
      this.docResultsList.paginator.firstPage();
      this.documentCount = this.docResultsList.filteredData.length;
    }
  }

  checkboxLabel(row?: any): string {
    //this.docIdArray = true
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row 
    ${row.position + 1}`;
  }

  public onCheckAllChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectAll();
    } else {
      this.deselectAll();
    }
  }

  private selectAll(): void {
    this.selection.select(...this.docResultsList.filteredData.map((row) => row));
  }

  private deselectAll(): void {
    this.selection.clear();
  }

  selectPage(pageOptions) {
    this.pageIndex = pageOptions.pageIndex;
    this.pageSize = pageOptions.pageSize;
    let currentPageSize = this.pageSize;    
    this.currentStartPageIndex = (this.pageIndex * this.pageSize) + 1;
    currentPageSize = currentPageSize * (this.pageIndex + 1);
    if (currentPageSize >= this.documentCount && currentPageSize < this.totalDocumentCount) {
      this.offset += 200;
      if (this.selectedTab === "Folder") {
        this.selectFolderPagination(this.selectedFolderName, this.selectedFolderId);
      } else {
        this.selectTeamPagination(this.selectedTeamName, this.selectedTeamId, this.selectedType, this.selectedParentTeam);
      }
    }
    this.currentPageSize = currentPageSize;
  }

  assignTeam(team) {
    let selectedList = this.selection.selected;
    let docIdsList = [];
    if (selectedList && selectedList.length > 0) {
      for (let index in selectedList) {
        docIdsList.push(selectedList[index]['documentId']);
      }
    }
    let request = {
      "team_Id": team['id'],
      "folder_Id": this.selectedFolderId,
      "document_Ids": docIdsList
    };
    this.migrationService.assignTeam(request).subscribe(resp => {
      if (resp && resp == 'Document already assigned') {
        this.alertService.error("Selected documents are already assigned to the selected team");              
      } else{
        this.alertService.success("Documents assigned to team successfully");
        setTimeout(() => {
          this.refresh();
        }, 2000);
      }
    }, error => {
      this.alertService.error("Document assignment failed");
    });
  }

  deleteDocument() {
    let selectedList = this.selection.selected;
    let docIdsList = [];
    if (selectedList && selectedList.length > 0) {
      for (let index in selectedList) {
        docIdsList.push(selectedList[index]['documentId']);
      }
    }
    let request = {
      "document_Ids": docIdsList
    };
    this.migrationService.deleteDocument(request).subscribe(resp => {
      if (resp && resp != 'Document not found in database') {                
        this.alertService.success("Documents deleted successfully");
        setTimeout(() => {
          this.refresh();
        }, 2000);      
      } else{
        this.alertService.error("Document deletion failed");
      }
    }, error => {
      this.alertService.error("Document deletion failed");
    });
  }

  assign(group) {
    
  }

  refresh() {
    if (this.selectedTab === "Folder") {
      this.selectFolder(this.selectedFolderName, this.selectedFolderId);
    } else {
      this.selectTeam(this.selectedTeamName, this.selectedTeamId, this.selectedType, this.selectedParentTeam);
    }
  }

  createSubFolder() {
    this.isMainPage = true;
    this.isCreateFolder = false;
    this.isUpdateFolder = false;
    this.isCreateSubFolder = true;
  }

  selectTeam(name, id, type, parent_id) {
    this.isCreateFolder = false;
    this.isCreateSubFolder = false;
    this.isUpdateFolder = false;
    this.isMainPage = false;
    this.selectedTeamName = name;
    this.selectedTeamId = id; 
    this.selectedType = type;
    this.selectedParentTeam = parent_id;
    this.documentCols = [      
      'documentName',
      'filesize'
    ];
    let folderId = id;
    let teamId = id;
    if(type === "folder"){
      this.teamSelectMessage = false;
      teamId = parent_id;
      this.migrationService.getTeam(teamId, type, folderId, this.offset).subscribe((documents) => {
        this.folderSelected = true;
        if (
          documents.Message ==
          'No records have been found matching the search criteria'
        ) {
          this.noDocuments = true;
          this.totalDocumentCount = 0;
        } else {
          this.noDocuments = false;
          this.documents = documents;
          this.totalDocumentCount = documents.count;
          if (this.totalDocumentCount > this.offset + 200) {
            this.loadNext = true;
          }
          if (this.offset >= 200) {
            this.loadPrevious = true;
          }
          this.documentCount = this.documents.results.length;
          //Get dynamic document columns
          // var categoryKeys = documents['results'][0];
          // var additionalCols: String[] = [];
          // Object.keys(categoryKeys).forEach(function (key) {
          //   if (key.startsWith('display_')) {
          //     additionalCols.push(key);
          //   }
          // });
  
          // for (var i = 0; i < additionalCols.length; i++) {
          //   this.documentCols.push(additionalCols[i]);
          // }
          this.documentCols.push("display_Water Right ID");
          // Sort documents by file_name in ascending order (A-Z)
          this.documents.results.sort((a, b) => {
            const nameA = (a.documentName || '').toLowerCase();
            const nameB = (b.documentName || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });
          this.docResultsList = new MatTableDataSource(this.documents.results);
          this.docResultsList.sort = this.sort;
          this.docResultsList.paginator = this.paginator;
        }
      }, error => {
        this.alertService.error("Selected folder/team doesn't have any shared files");
      });
    } else {
      this.teamSelectMessage = true;
      this.noDocuments = false;
      this.totalDocumentCount = 0;
    }
    
  }

  selectTeamPagination(name, id, type, parent_id) {
    this.isCreateFolder = false;
    this.isCreateSubFolder = false;
    this.isUpdateFolder = false;
    this.isMainPage = false;
    this.selectedTeamName = name;
    this.selectedTeamId = id; 
    this.selectedType = type;
    this.selectedParentTeam = parent_id;
    this.documentCols = [      
      'documentName',
      'filesize'
    ];
    let folderId = id;
    let teamId = id;
    if(type === "folder"){
      this.teamSelectMessage = false;
      teamId = parent_id;
      this.migrationService.getTeam(teamId, type, folderId, this.offset).subscribe((documents) => {
        this.folderSelected = true;
        if (
          documents.Message ==
          'No records have been found matching the search criteria'
        ) {
          this.noDocuments = true;
          this.totalDocumentCount = 0;
        } else {
          this.noDocuments = false;
          // this.documents = documents;
          this.totalDocumentCount = documents.count;
          if (this.totalDocumentCount > this.offset + 200) {
            this.loadNext = true;
          }
          if (this.offset >= 200) {
            this.loadPrevious = true;
          }
          this.documentCount += documents.results.length;
          //Get dynamic document columns
          // var categoryKeys = documents['results'][0];
          // var additionalCols: String[] = [];
          // Object.keys(categoryKeys).forEach(function (key) {
          //   if (key.startsWith('display_')) {
          //     additionalCols.push(key);
          //   }
          // });
  
          // for (var i = 0; i < additionalCols.length; i++) {
          //   this.documentCols.push(additionalCols[i]);
          // }
          // documents.results.forEach(element => {
          //   this.documents.results.push(element);
          // });
          this.documentCols.push("display_Water Right ID");
          // Sort documents by file_name in ascending order (A-Z)
          this.documents.results.sort((a, b) => {
            const nameA = (a.documentName || '').toLowerCase();
            const nameB = (b.documentName || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });
          this.docResultsList = new MatTableDataSource(this.documents.results);
          this.docResultsList.sort = this.sort;
          this.docResultsList.paginator = this.paginator;
        }
      }, error => {
        this.alertService.error("Selected folder/team doesn't have any shared files");
      });
    } else {
      this.teamSelectMessage = true;
      this.noDocuments = false;
      this.totalDocumentCount = 0;
    }
    
  }

  selectFolder(name, id) {
    this.isCreateFolder = false;
    this.isCreateSubFolder = false;
    this.isUpdateFolder = false;
    this.isMainPage = false;
    this.teamSelectMessage = false;
    this.selection.clear();
    this.selectedFolderName = name;
    this.selectedFolderId = id;    
    this.fullPath = this.findPathOfSelectedFolder(id, name);
    this.documentCols = [
      'select',
      'documentName',
      'filesize'
    ];
    this.virtualFolderService.get(id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents.Message ==
        'No records have been found matching the search criteria'
      ) {
        this.noDocuments = true;
        this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount = this.documents.results.length;
        //Get dynamic document columns
        // var categoryKeys = documents['results'][0];
        // var additionalCols: String[] = [];
        // Object.keys(categoryKeys).forEach(function (key) {
        //   if (key.startsWith('display_')) {
        //     additionalCols.push(key);
        //   }
        // });

        // for (var i = 0; i < additionalCols.length; i++) {
        //   this.documentCols.push(additionalCols[i]);
        // }
        this.documentCols.push("display_Water Right ID");
        // Sort documents by file_name in ascending order (A-Z)
        this.documents.results.sort((a, b) => {
          const nameA = (a.documentName || '').toLowerCase();
          const nameB = (b.documentName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.docResultsList = new MatTableDataSource(this.documents.results);
        this.docResultsList.sort = this.sort;
        this.docResultsList.paginator = this.paginator;
      }
      localStorage.setItem('fileInboxFolderId', this.selectedFolderId);
    });
  }

  selectFolderPagination(name, id) {
    this.isCreateFolder = false;
    this.isCreateSubFolder = false;
    this.isUpdateFolder = false;
    this.isMainPage = false;
    this.teamSelectMessage = false;
    this.selection.clear();
    this.selectedFolderName = name;
    this.selectedFolderId = id;    
    this.fullPath = this.findPathOfSelectedFolder(id, name);
    this.documentCols = [
      'select',
      'documentName',
      'filesize'
    ];
    this.virtualFolderService.get(id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents.Message ==
        'No records have been found matching the search criteria'
      ) {
        this.noDocuments = true;
        this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        // this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount += documents.results.length;
        //Get dynamic document columns
        var categoryKeys = documents['results'][0];
        // var additionalCols: String[] = [];
        // Object.keys(categoryKeys).forEach(function (key) {
        //   if (key.startsWith('display_')) {
        //     additionalCols.push(key);
        //   }
        // });

        // for (var i = 0; i < additionalCols.length; i++) {
        //   this.documentCols.push(additionalCols[i]);
        // }
        // documents.results.forEach(element => {
        //   this.documents.results.push(element);
        // });
        this.documentCols.push("display_Water Right ID");
        // Sort documents by file_name in ascending order (A-Z)
        this.documents.results.sort((a, b) => {
          const nameA = (a.documentName || '').toLowerCase();
          const nameB = (b.documentName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.docResultsList = new MatTableDataSource(this.documents.results);
        this.docResultsList.sort = this.sort;
        this.docResultsList.paginator = this.paginator;
      }
    });
  }

  findPathOfSelectedFolder(id, name) {
    const folderStack = new Stack<string>();
    let isRootNode = false;
    let path = "";
    if (this.allVirtualFolders && this.allVirtualFolders.length > 0) {
      while(!isRootNode) {
        let selectedFolder = this.allVirtualFolders.filter(folder => folder.id == id);
        if (selectedFolder && selectedFolder.length > 0) {
          folderStack.push(selectedFolder[0].folder_name);
          if (selectedFolder[0].parent_id == 0) {
            isRootNode = true;
          } else {
            id = selectedFolder[0].parent_id;
          }
        } else {
          isRootNode = true;
          folderStack.push(name);
        }
      }
      while(!folderStack.isEmpty()) {
        path += folderStack.pop() + "/";
      }
    }
    return path;
  }

  findTeamOfSelectedFolder(id) {
    const folderStack = new Stack<string>();
    let isRootNode = false;    
    if (this.allVirtualTeams && this.allVirtualTeams.length > 0) {
      while(!isRootNode) {
        let selectedFolder = this.allVirtualTeams.filter(folder => folder.id == id);
        if (selectedFolder && selectedFolder.length > 0) {
          folderStack.push(selectedFolder[0].id);
          if (selectedFolder[0].type == 0) {
            isRootNode = true;
          } else {
            id = selectedFolder[0].parent_id;
          }
        } else {
          isRootNode = true;          
        }
      }      
    }
    return folderStack.pop();
  }

  findChildIds(folderIds, id) {
    let childNodeList = this.allVirtualFolders.filter(folder => folder.parent_id == id);
    if (childNodeList.length > 0) {
      for (let index in childNodeList) {
        folderIds.push(childNodeList[index]['id']);
        this.findChildIds(folderIds, childNodeList[index]['id']);
      }
    }
  }

  findListofIdFromSelectedFolder(id) {
    let folderIds = [];
    if (this.allVirtualFolders && this.allVirtualFolders.length > 0) {
      folderIds.push(id);
      this.findChildIds(folderIds, id);      
    }
    return folderIds;
  }

  updateFolder(id) {
    this.isUpdateFolder = true;
    this.isMainPage = true;
    this.isCreateFolder = false;
    this.isCreateSubFolder = false;
    this.noDocuments = false;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.docResultsList.data.length;
    return numSelected === numRows;
  }

  createFolder() {
    this.isMainPage = true;
    this.isCreateFolder = true;
    this.isCreateSubFolder = false;
    this.isUpdateFolder = false;
    this.folderSelected = false;
  }

  deleteFolder() {
    let folderIds = this.findListofIdFromSelectedFolder(this.selectedFolderId);
    let request = {
      "folder_Ids": folderIds
    };
    this.migrationService.deleteFolder(request).subscribe(resp => {
      if (resp && resp != 'Folder not found in database') {                
        this.alertService.success("Folder deleted successfully");
        setTimeout(() => {
          localStorage.removeItem('fileInboxFolderId');
          this.selectedFolderId = 0;
          this.getVirtualFoldersTree();
        }, 2000);      
      } else{
        this.alertService.error("Folder deletion failed");
      }
    }, error => {
      this.alertService.error("Folder deletion failed");
    });
  }

  uploadCaptureDocument() {
    let dialogRef = this.dialog.open(DialogCaptureUploadComponent,
      { width: '100%', height: "80%", data: { folderName: this.selectedFolderName, folderId: this.selectedFolderId, folderPath: this.fullPath} });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        //this.getGroups();
        // this.reload.emit(true);
        // this.noDocuments=false;
        this.selectFolder(this.selectedFolderName, this.selectedFolderId);
      }
    });
  }

  onHideDocList(hide: boolean) {
    if (hide) {
      this.hideDocList = true;
    } else {
      this.hideDocList = false;
      this.drawerContainer.open();
      this.selectFolder(this.selectedFolderName, this.selectedFolderId);
    }
  }
  next() {
    this.offset = this.offset + 200;
    this.selectFolder(this.selectedFolderName, this.selectedFolderId);
  }

  previous() {
    this.offset = this.offset - 200;
    this.selectFolder(this.selectedFolderName, this.selectedFolderId);
  }

  onReturnPage(hide: boolean) {
    if (hide) {
      this.isMainPage = false;
      this.ngOnInit();
      this.isCreateFolder = false;
      this.isCreateSubFolder = false;
      this.isUpdateFolder = false;
      this.folderSelected = false;
      this.noDocuments = false;
    } else {
      this.isMainPage = false;
      this.isCreateFolder = false;
      this.isCreateSubFolder = false;
      this.isUpdateFolder = false;
      this.folderSelected = false;
      this.noDocuments = false;
    }
  }

  alertErrorMessage(message: string){
    this.alertService.error(message);
  }

  search() {
    this.folders.filter((form) => {
      if (
        form.folder_name
          .trim()
          .toLowerCase()
          .indexOf(this.filterValue.trim().toLowerCase()) > -1
      ) {
        this.navBarFolders.push(form);
      }
      if (form.sub_folders) {
        form.sub_folders.filter((element) => {
          if (
            element.folder_name
              .trim()
              .toLowerCase()
              .indexOf(this.filterValue.trim().toLowerCase()) > -1
          ) {
            this.navBarFolders.push(form);
          }
        });
      }
      this.navBarFolders = this.navBarFolders.filter((elem, i, arr) => {
        if (arr.indexOf(elem) === i) {
          return elem;
        }
      });
    });
    this.virtualFolders.data = this.navBarFolders;
  }

  searchTeams() {
    this.teams.filter((form) => {
      if (
        form.folder_name
          .trim()
          .toLowerCase()
          .indexOf(this.filterValue.trim().toLowerCase()) > -1
      ) {
        this.navBarTeams.push(form);
      }
      if (form.sub_folders) {
        form.sub_folders.filter((element) => {
          if (
            element.folder_name
              .trim()
              .toLowerCase()
              .indexOf(this.filterValue.trim().toLowerCase()) > -1
          ) {
            this.navBarTeams.push(form);
          }
        });
      }
      this.navBarTeams = this.navBarTeams.filter((elem, i, arr) => {
        if (arr.indexOf(elem) === i) {
          return elem;
        }
      });
    });
    this.virtualTeams.data = this.navBarTeams;
  }
  
  stringContainsAny(str: string, substrings: string[]): boolean {
    let strArray = str.split(".");
    let extension = '';
    if (strArray.length > 1) {
      extension = '.'+strArray[strArray.length - 1];
    }
    return substrings.some(substring => extension.includes(substring));
  }

  viewDocument(doc) {
    //console.log("doc id " + this.documentID);
    const msOfficeFiles = [".doc", ".docx", ".xls", ".xlsx", ".csv", ".ppt", ".pptx", ".dotx", ".dotm",".docm", ".xlsb", ".xlam", ".pst", ".rtf"];
    
    const result = this.stringContainsAny(doc.documentName, msOfficeFiles);
    if (result) {
      this.documentService.viewCaptureDocument(doc.documentId)
        .subscribe(
          resp => {            
            //console.log("View document " + resp);
            var url = resp.slice(5);
            this.httpClient.get(url, { responseType: 'blob' })
            .subscribe(blob => {
              saveAs(blob, doc.documentName);
            });
          }
        );
    } else {
      this.documentService.viewCaptureDocument(doc.documentId)
        .subscribe(
          resp => {            
            //console.log("View document " + resp);
            var url = resp.slice(5);
            //window.open(url);
            window.open(url, '_blank', 'location=yes,height=900,width=900,scrollbars=yes,status=yes');
          }
        );
    }
  }

}
